import { combineReducers } from 'redux';

const TABLE_DATA_INIT_STATE = {
  table_rows: [],
  table_rows_count: 0,
  isFetching: false
}

const TABLE_OPTION_INIT_STATE = {
  pagination: {
    page: 1,
    perPage: 10
  },
  sortingColumns: {}
}

function listTableData (state = TABLE_DATA_INIT_STATE, action) {
  switch (action.type) {
    case 'FETCH_LIST_TABLE_ROWS_INPROGRESS': {
      return { 
        ...state, 
        isFetching: true 
      };
    } 
    case 'SILENT_FETCH_LIST_TABLE_ROWS_INPROGRESS': {
      return {
        ...state,
        isFetching: true,
        isSilentRefresh: true
      }
    }  
    case 'SILENT_FETCH_LIST_TABLE_ROWS_ERROR': {
      const { error } = action;
      return {
        error: error
      }
    }  
    case 'FETCH_LIST_TABLE_ROWS_ERROR': {
      const { error } = action;
      return {
        error: error
      }
    }  
    case 'FETCH_LIST_TABLE_ROWS_DONE':
      return { 
        ...state, 
        table_rows: action.payload.rows, 
        table_rows_count: action.payload.total_rows, 
        isFetching: false 
      };
    default:
      return state
  }
}

function listTableOptions (state = TABLE_OPTION_INIT_STATE, action) {
  switch (action.type) {
    case 'SET_LIST_TABLE_OPTIONS' :
      let options = action.options;
      return { ...state, pagination: options.pagination, sortingColumns: options.sortingColumns }
    default:
      return state
  }
}

const listTableReducer = combineReducers ({
  data: listTableData,
  options: listTableOptions
})

export default listTableReducer;

